import { PiShovelDuotone } from "react-icons/pi";
import { Card } from "src/components/card";
import { LeftSidebar } from "src/components/left-sidebar";
import { PageBase } from "src/components/page-base";
import { ToolSearch } from "../components/tool-search";
import { useSearchParams } from "react-router-dom";
import { useRoles } from "src/context/roles-context";
import { ModifyRepresentatives } from "../components/modify-rep";
import { ModifyWorksiteRepresentatives } from "../components/modify-worksite-rep";
import { DriverSupervisorMap } from "../components/driver-supervisor-mapping";
import { YellowMarkedDisplay } from "../components/yellow-marked";
import { LastWorkDate } from "../components/last-work-date";
import { HR_TOOLS } from "../constants/HRTools";

const toolComponentMap: Record<string, React.ReactNode> = {
  "Modify Org Representative": <ModifyRepresentatives />,
  "Modify Worksite Representative": <ModifyWorksiteRepresentatives />,
  "Driver Supervisor Mapping": <DriverSupervisorMap/>,
  "Yellow Marked Employees": <YellowMarkedDisplay/>,
  "Termination Workflow Request": <LastWorkDate />,
};

export function IndexPage() {
   const userPermited = true;
   const roles = useRoles();
   const access = roles.checkHasRole("HRConfigMgt.Engauge") || roles.checkHasRole("HRConfigMgt.EngaugeBeta");
   const [searchParams, setSearchParams] = useSearchParams();
   const activeTool = searchParams.get("tool") ?? "";

   function setActiveTool(tool: string)
   {
       setSearchParams(prev =>
           {
               prev.set("tool", tool);
               return prev;
           }
       );
   }
   return (
           <>
               {access ? (<PageBase pageName="HR Config Management" userPermitted={userPermited}>
                   <>
                       <LeftSidebar
                           extendedWidth="w-[400px]"
                           title="HR Config Management"
                           icon={
                               <PiShovelDuotone className="w-8 h-8 mr-2 text-[#ac2226]" />
                           }
                           collapsedContent={
                               <div className="[writing-mode:vertical-rl] font-bold text-lg flex items-center m-6">
                                   HR Config Management
                               </div>
                           }
                           >

                           <div className="flex flex-col gap-2">
                               <Card customization="">
                                   <ToolSearch
                                       tools={HR_TOOLS}
                                       categoryLabel="HR Tools"
                                       onToolSelect={setActiveTool}
                                       initialTool={activeTool}
                                   />
                               </Card>

                           </div>

                       </LeftSidebar>

                       <div className="flex-1 flex flex-col overflow-hidden p-8 gap-8 bg-gray-900">
                           {activeTool && toolComponentMap[activeTool] ? toolComponentMap[activeTool]: activeTool
                           ? <p className="text-sm text-gray-500">"{activeTool}" is not yet implemented.</p> : null
                           }
                       </div>
                   </>
               </PageBase> ) : (
                   <div className="p-4 label-text text-white">
                       Permission denied, you shouldn't be here...
                   </div>
               )}
           </>
       );
}